export default __webpack_public_path__ + "static/media/1374.4290f3a6.png";